import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
  padding: 4rem 5rem 8rem;
  border-radius: 10px;
  background-color: ${colors.neutral.white};
`;

export const ContentTitleStyled = styled.h3`
  ${typography.bold[24]};
  color: ${colors.neutral[900]};
  padding: 0 0 1rem;
  margin: 0;
`;

export const ContentSubtitleStyled = styled.p`
  ${typography.regular[16]};
  color: ${colors.neutral[900]};
  padding: 0 0 3rem;
  margin: 0;
  border-bottom: 1px solid ${colors.neutral[300]};
`;

export const HealthQuestionnaireStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding-top: 4rem;
`;
